import React, { useEffect, useState } from "react";
import { useI18n } from "@/lib/i18n";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";

export default function Testimonials() {
  const { t } = useI18n();
  const list = t.testimonials.list;
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setIdx((v) => (v + 1) % list.length), 7000);
    return () => clearInterval(id);
  }, [list.length]);

  return (
    <section data-testid="testimonials-section" className="relative bg-onyx py-24 lg:py-40 overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-12 gap-6 mb-16">
          <div className="col-span-12 lg:col-span-7">
            <div className="eyebrow mb-6 flex items-center gap-3">
              <span className="w-8 h-px bg-brass" /> {t.testimonials.eyebrow}
            </div>
            <h2 className="font-display text-[2.4rem] sm:text-5xl lg:text-6xl text-bone leading-[1] tracking-tight">
              {t.testimonials.title_1} <span className="italic-display text-brass">{t.testimonials.title_2}</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-6 lg:gap-10 items-start">
          <div className="hidden lg:block lg:col-span-1">
            <Quote className="w-10 h-10 text-brass/60" strokeWidth={1} />
          </div>

          <div className="col-span-12 lg:col-span-8">
            <blockquote
              key={idx}
              data-testid="testimonial-quote"
              className="font-display text-[1.6rem] sm:text-3xl lg:text-[2.4rem] text-bone leading-snug tracking-tight animate-fade-up"
            >
              “{list[idx].q}”
            </blockquote>
            <div className="mt-8 flex items-center gap-4 animate-fade-up [animation-delay:200ms]">
              <div className="w-12 h-12 rounded-full bg-graphite border border-bone/10 grid place-items-center font-display text-brass">
                {list[idx].n.split(" ").map((s) => s[0]).slice(0, 2).join("")}
              </div>
              <div>
                <div className="text-bone text-sm">{list[idx].n}</div>
                <div className="text-taupe text-xs tracking-[0.18em] uppercase">{list[idx].c}</div>
              </div>
            </div>
          </div>

          <div className="col-span-12 lg:col-span-3 flex lg:flex-col items-center lg:items-end justify-between gap-6 lg:gap-8 lg:pt-4">
            <div className="font-display text-5xl text-bone">
              <span className="text-brass">{idx + 1}</span>
              <span className="text-bone/40">/{list.length}</span>
            </div>
            <div className="flex gap-2">
              <button
                data-testid="testimonial-prev"
                onClick={() => setIdx((v) => (v - 1 + list.length) % list.length)}
                className="w-12 h-12 grid place-items-center border border-bone/15 text-bone hover:border-brass hover:text-brass transition-colors"
              >
                <ChevronLeft className="w-5 h-5" />
              </button>
              <button
                data-testid="testimonial-next"
                onClick={() => setIdx((v) => (v + 1) % list.length)}
                className="w-12 h-12 grid place-items-center border border-bone/15 text-bone hover:border-brass hover:text-brass transition-colors"
              >
                <ChevronRight className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
